import { render, staticRenderFns } from "./CoursePinCode.vue?vue&type=template&id=4b21f87d&"
import script from "./CoursePinCode.vue?vue&type=script&lang=js&"
export * from "./CoursePinCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports